import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";

import { apiRoot } from "../consts";

// Намеренно узкий набор: перекрывать queryKey/queryFn отсюда нельзя,
// иначе инвалидация по ключу перестанет работать предсказуемо
type QueryOverrides<T> = Pick<
  UseQueryOptions<T>,
  "refetchInterval" | "refetchIntervalInBackground" | "staleTime"
>;

export const useDataQueryParams = <T = any>(
  basePath: string,
  params: Record<string, string | number | undefined> = {},
  root: string = apiRoot,
  skip = false,
  overrides: QueryOverrides<T> = {},
): T | undefined => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== "",
    ),
  ) as Record<string, string | number>;

  const search = new URLSearchParams(
    Object.fromEntries(
      Object.entries(cleanParams).map(([key, value]) => [key, String(value)]),
    ),
  ).toString();

  const { data } = useQuery<T>({
    queryKey: [basePath, cleanParams],
    queryFn: async () => {
      const url = root + basePath + (search ? `?${search}` : "");
      const result = await axios(url, { withCredentials: true });

      if (result.status !== 200) {
        throw new Error("Network response was not ok");
      }

      return result.data;
    },
    enabled: !skip,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 1,
    gcTime: 5 * 60 * 1000,
    ...overrides,
  });

  return data;
};
